import React, { FC } from 'react';
import cn from 'classnames';
import './Label.css';

export type LabelSize =
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'heading-sm'
  | 'heading-md'
  | 'heading-l'
  | 'heading-lg'
  | 'heading-xl'
  | 'heading-xs'
  | 'heading-xxs';

interface LabelProps extends React.ComponentPropsWithoutRef<'label'> {
  size?: LabelSize;
  bold?: boolean;
  noBreak?: boolean;
}

export const Label: FC<LabelProps> = ({
  size = 'md',
  bold = false,
  noBreak = false,
  ...props
}) => {
  const classNames = cn('label', size, {
    bold: bold,
    noBreak: noBreak,
  });

  return (
    <label className={classNames} {...props}>
      {props.content}
    </label>
  );
};

export default Label;
